import React, { useEffect, useState } from 'react'
import { Dropdown, Accordion, Form, Image, Button } from 'react-bootstrap'
import styles from '../pages/dashboard/Dashboard.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import OutsideAlert from './OutsideAlert'
import jwt_decode from 'jwt-decode'
import axios from 'axios'
import _lang from 'lodash/lang'

interface ToggleProps {
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  style?: React.CSSProperties;
  className?: string;
  eventKey?: string;
}
interface CusMenu {
  children?: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  style?: React.CSSProperties;
  className?: string;
}

interface Data {
  services: {
    MICROSITE: any;
    VCF: any;
    KIOSK: any;
  };
}

const CustomMenu = React.forwardRef<HTMLDivElement, CusMenu>(
	({ children, className }, ref) => {
		const style = {
			borderRadius: '0px 0px 24px 24px',
			backgroundColor: 'white',
			border: '2px solid #F1F4FA',
			borderTop: '0px',
			outline: 0,
			boxShadow: 'none',
			width: '100%',
			// padding:"6px"
		}

		return (
			<div ref={ref} style={style} className={className}>
				{children}
			</div>
		)
	}
)
CustomMenu.displayName = 'CusMenu'

const Filter: React.FC = () => {
	const [clicked, setClicked] = useState(false)

	const [microsite, setMicrosite] = useState<any[]>([])
	const [vcf, setVcf] = useState<any[]>([])
	const [kiosk, setKiosk] = useState<any[]>([])

	const [selectedMicrosite, setSelectedMicrosite] = useState<any[]>([])
	const [selectedVcf, setSelectedVcf] = useState<any[]>([])
	const [selectedKiosk, setSelectedKiosk] = useState<any[]>([])
	const [selectedLabel, setSelectedLabel] = useState<any[]>([])
	const [currentSelectedLabel, setCurrentSelectedLabel] = useState<any[]>([])
	const [kioskType, setKioskType] = useState<string[]>([])

	const getKioskType = (ids) => {
		const type: string[] = []
		const hasDawn = ids.some((id) => id >= 101 && id <= 199)
		const hasXH = ids.some((id) => id >= 201 && id <= 299)
		const hasZann = ids.some((id) => id >= 301 && id <= 399)

		if (hasDawn) type.push('Dawn')
		if (hasXH) type.push('XH')
		if (hasZann) type.push('Zann')
		return type
	}

	const initialData = async () => {
		const selectedMicrosite = JSON.parse(
      localStorage.getItem('selectedMicrosite') as string
		)
		setSelectedMicrosite(selectedMicrosite)

		const selectedVcf = JSON.parse(
      localStorage.getItem('selectedVcf') as string
		)
		setSelectedVcf(selectedVcf)

		const selectedKiosk = JSON.parse(
      localStorage.getItem('selectedKiosk') as string
		)
		setSelectedKiosk(selectedKiosk)

		const selectedLabel = JSON.parse(
      localStorage.getItem('selectedLabel') as string
		)
		setSelectedLabel(selectedLabel)
		setCurrentSelectedLabel(selectedLabel)

		if (!_lang.isEmpty(selectedKiosk)) {
			setKioskType(getKioskType(selectedKiosk))
		} else {
			setKioskType(getKioskType(kiosk.map((k) => k.id)))
		}
	}

	const getServices = async () => {
		const token = localStorage.getItem('token')
		const res = await axios.get(
      process.env.REACT_APP_ROUTE_GET_ALL_SERVICES as string
		)

		const tokenData: Data = jwt_decode(token as string)

		const allowedMicrosite: string[] = []
		res.data.MICROSITE.map((microsite: string) => {
			if (tokenData.services.MICROSITE.includes(microsite)) {
				allowedMicrosite.push(microsite)
			}
		})

		const vcf: any[] = []
		tokenData.services.VCF.map((data: any) => {
			vcf.push(parseInt(data as unknown as string))
		})
		const allowedVcf: string[] = []
		res.data.VCF.map((data: any) => {
			if (vcf.includes(data.id)) {
				allowedVcf.push(data)
			}
		})

		const kiosk: any[] = []
		tokenData.services.KIOSK.map((data: any) => {
			kiosk.push(parseInt(data as unknown as string))
		})
		const allowedKiosk: string[] = []
		res.data.KIOSK.map((data: any) => {
			if (kiosk.includes(data.id)) {
				allowedKiosk.push(data)
			}
		})

		setMicrosite(allowedMicrosite)
		setVcf(allowedVcf)
		setKiosk(allowedKiosk)
	}

	useEffect(() => {
		getServices()
	}, [])

	useEffect(() => {
		initialData()
	}, [kiosk])

	useEffect(() => {
		localStorage.setItem(
			'selectedMicrosite',
			JSON.stringify(selectedMicrosite)
		)
		localStorage.setItem('selectedVcf', JSON.stringify(selectedVcf))
		localStorage.setItem('selectedKiosk', JSON.stringify(selectedKiosk))
		localStorage.setItem('selectedLabel', JSON.stringify(selectedLabel))
		localStorage.setItem('kioskType', JSON.stringify(kioskType))
	}, [selectedMicrosite, selectedVcf, selectedKiosk, kioskType])

	const removeArray = (
		arr: any[],
		removedValue: number | React.ChangeEvent<HTMLInputElement>
	) => {
		return arr.filter((element: any) => {
			return element !== removedValue
		})
	}

	const getKioskId = (name: any, id: number) => {
		// if Select All is selected

		if (name === 'all') {
			// Unselect
			if (selectedKiosk.length === kiosk.length) {
				setSelectedKiosk([])

				const toRemove = new Set(kiosk.map((item) => item.name))
				setSelectedLabel(selectedLabel.filter((x) => !toRemove.has(x)))
			} else {
				const kioskIds = kiosk.map((ele) => ele.id)
				const kioskLabels = kiosk.map((ele) => ele.name)

				setSelectedKiosk(kioskIds)
				setSelectedLabel(kioskLabels)
			}
		} else {
			if (selectedKiosk.includes(id)) {
				const newSelectedKiosk = removeArray(selectedKiosk, id)
				setSelectedKiosk(newSelectedKiosk)

				const newSelectedLabel = removeArray(selectedLabel, name)
				setSelectedLabel(newSelectedLabel)
			} else {
				setSelectedKiosk((data) => [...data, id])
				setSelectedLabel((data) => [...data, name])
			}
		}
	}

	const CustomToggle = React.forwardRef<HTMLAnchorElement, ToggleProps>(
		({ children, onClick }, ref) => {
			return (
				<a
					href=""
					ref={ref}
					onClick={(e) => {
						e.preventDefault()
						onClick(e)
						setClicked(!clicked)
					}}
				>
					{children}
				</a>
			)
		}
	)

	function refreshPage() {
		window.location.reload()
	}

	CustomToggle.displayName = 'CusFilter'

	return (
		<>
			<OutsideAlert clickFn={setClicked}>
				<Dropdown
					onToggle={(e) => {
						if (!e && selectedLabel !== currentSelectedLabel) {
							refreshPage()
						}
					}}
				>
					<Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
						<Button
							className={clicked ? styles.accClicked : styles.accNtClicked}
						>
							<FontAwesomeIcon icon={faFilter} />
							<span style={{ paddingLeft: '0.5rem' }}>
								{selectedLabel.length !== 0 ? (
									selectedLabel.map((data, i) => {
										if (i > 5) return
										return (
											<span
												className="badge"
												style={{
													backgroundColor: '#EDF3FA',
													color: '#5B7493',
													marginRight: '4px',
												}}
												key={i}
											>
												{i === 5 ? '...' : data}
											</span>
										)
									})
								) : (
									<span
										className="badge"
										style={{
											backgroundColor: '#EDF3FA',
											color: '#5B7493',
											marginRight: '4px',
										}}
									>
                    All
									</span>
								)}
							</span>
						</Button>
					</Dropdown.Toggle>
					<Dropdown.Menu as={CustomMenu}>
						<Accordion flush defaultActiveKey="1">
							<Accordion.Item
								eventKey="1"
								style={{
									borderBottom: '0px',
									maxHeight: '510px',
									overflowY: 'scroll',
								}}
							>
								{kiosk.length !== 0 && (
									<Accordion.Body
										className={styles.accBody}
										style={{ border: 'none' }}
									>
										{/* <div className='mt-2 mb-2'>
												<Image src='/img/kiosks.png' alt='jobstations' width='15' height='23' />
												<span style={{ fontWeight: '600', paddingLeft: '1rem', color: 'black' }}>Job Stations</span>
											</div> */}
										<Form.Check type="checkbox" id="all-kiosk">
											<Form.Check.Input
												style={{ border: '1px solid #DEE7F2' }}
												type="checkbox"
												onChange={() => getKioskId('all', 0)}
												checked={selectedKiosk.length === kiosk.length}
											/>
											<Form.Check.Label
												style={{
													paddingLeft: '13px',
													color: '#3d5069',
													fontWeight: 'bold',
												}}
											>
                        Select All
											</Form.Check.Label>
										</Form.Check>
										{kiosk.map((location: any, key: number) => (
											<div key={key} className="mb-1">
												<Form.Check
													name={location.id}
													type="checkbox"
													id={'kiosk-' + location.id}
												>
													<Form.Check.Input
														style={{ border: '1px solid #DEE7F2' }}
														type="checkbox"
														onChange={() =>
															getKioskId(location.name, location.id)
														}
														checked={selectedKiosk.includes(location.id)}
													/>
													<Form.Check.Label
														style={{ paddingLeft: '13px', color: '#5B7493' }}
													>
														{location.name}
													</Form.Check.Label>
												</Form.Check>
											</div>
										))}
									</Accordion.Body>
								)}
							</Accordion.Item>
						</Accordion>
					</Dropdown.Menu>
				</Dropdown>
			</OutsideAlert>
		</>
	)
}

export default Filter
